export default {
  'pages.repository.section.basic': '基本資訊',
  'pages.repository.section.gitlab': 'GitLab 同步',
  'pages.repository.section.permissions': '成員權限',
  'pages.repository.create.success': '程式碼倉庫建立成功',
  'pages.repository.create.failed': '程式碼倉庫建立失敗',
  'pages.repository.update.success': '程式碼倉庫更新成功',
  'pages.repository.update.failed': '程式碼倉庫更新失敗',
  'pages.repository.gitlab.sync': '同步到 GitLab',
  'pages.repository.gitlab.sync.description':
    '開啟後會先建立以專案標識命名的 GitLab 群組，再在群組下建立倉庫。倉庫網址由系統自動維護。',
  'pages.repository.gitlab.retrySync': '重新同步到 GitLab',
  'pages.repository.gitlab.retrySync.description':
    '目前尚未連結 GitLab 專案。開啟並儲存後，將重新建立或連結專案群組與倉庫。',
  'pages.repository.gitlab.creationOrder.title': 'GitLab 建立路徑',
  'pages.repository.gitlab.creationOrder.description':
    '儲存後依序建立：專案群組（名稱與路徑使用專案標識）→ 程式碼倉庫（路徑使用倉庫標識）。',
  'pages.repository.gitlab.editPermissions.title': '管理 GitLab 倉庫成員權限',
  'pages.repository.gitlab.editPermissions.description':
    '儲存後只會更新由超級軟體工廠管理的成員，不會移除 GitLab 內其他來源的成員。',
  'pages.repository.gitlab.pendingIdentifier': '待填寫標識',
  'pages.repository.gitlab.memberPermissions.title': '倉庫成員',
  'pages.repository.gitlab.memberPermissions.managedOnly':
    '僅管理 SSF 分配成員',
  'pages.repository.gitlab.memberPermissions.description':
    '從目前專案的活躍成員中分配倉庫權限。預設依專案角色建議，可按實際職責調整。',
  'pages.repository.gitlab.memberPermissions.empty': '尚未分配倉庫成員',
  'pages.repository.gitlab.memberPermissions.noProjectMembers':
    '目前專案沒有可分配的活躍成員，請先到專案成員設定新增成員。',
  'pages.repository.gitlab.memberPermissions.loadFailed':
    '無法載入 GitLab 成員權限。為避免誤刪成員，重新載入成功前無法儲存。',
  'pages.repository.gitlab.memberPermissions.loadUnavailable':
    '權限資料尚未成功載入，此處不會視為空清單。請重新載入後再編輯。',
  'pages.repository.gitlab.memberPermissions.retry': '重新載入',
  'pages.repository.gitlab.memberPermissions.tab': 'GitLab 權限',
  'pages.repository.gitlab.memberPermissions.save': '儲存權限',
  'pages.repository.gitlab.memberPermissions.saveSuccess':
    'GitLab 權限儲存成功',
  'pages.repository.gitlab.memberPermissions.saveFailed': 'GitLab 權限儲存失敗',
  'pages.repository.gitlab.memberPermissions.consistencyWarning':
    '畫面記錄可能與 GitLab 實際權限不一致',
  'pages.repository.gitlab.memberPermissions.consistencyWarning.description':
    '請檢查失敗成員的 GitLab 使用者名稱與目標權限，修正後可重新儲存以重試同步。',
  'pages.repository.gitlab.memberPermissions.syncStatus': '同步狀態：',
  'pages.repository.gitlab.memberPermissions.syncStatus.synced': '已同步',
  'pages.repository.gitlab.memberPermissions.syncStatus.pending': '待同步',
  'pages.repository.gitlab.memberPermissions.syncStatus.unmapped':
    '未匹配 GitLab 使用者',
  'pages.repository.gitlab.memberPermissions.syncStatus.failed': '同步失敗',
  'pages.repository.gitlab.memberPermissions.syncStatus.notSynced': '尚未同步',
  'pages.repository.gitlab.memberPermissions.syncError': '失敗原因：{error}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel':
    'GitLab 有效權限：{accessLevel}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel.unknown':
    '尚未確認',
  'pages.repository.gitlab.memberPermissions.inheritedAccess':
    '該成員從上級 GitLab 群組繼承了權限，倉庫層級設定無法將其降級或撤銷。',
  'pages.repository.gitlab.member': '專案成員',
  'pages.repository.gitlab.member.required': '請選擇專案成員',
  'pages.repository.gitlab.member.duplicate': '同一成員不能重複分配',
  'pages.repository.gitlab.member.placeholder': '選擇專案成員',
  'pages.repository.gitlab.member.add': '新增成員權限',
  'pages.repository.gitlab.member.remove': '移除成員權限',
  'pages.repository.gitlab.accessLevel': 'GitLab 權限',
  'pages.repository.gitlab.accessLevel.required': '請選擇 GitLab 權限',
  'pages.repository.gitlab.accessLevel.10': 'Guest（訪客）',
  'pages.repository.gitlab.accessLevel.20': 'Reporter（報告者）',
  'pages.repository.gitlab.accessLevel.30': 'Developer（開發者）',
  'pages.repository.gitlab.accessLevel.40': 'Maintainer（維護者）',
  'pages.repository.gitlab.projectContext.loadFailed':
    '無法載入專案標識或成員，GitLab 權限設定可能不完整。',
  'pages.repository.gitlab.memberSync.unknownError': '未知原因',
  'pages.repository.gitlab.memberSync.partialFailure':
    '{count} 位成員權限同步失敗：{details}',
  'pages.repository.gitlab.memberSync.inheritedAccess':
    '{count} 位成員仍從上級 GitLab 群組繼承權限，倉庫層級設定無法降級或撤銷：{members}',
  'pages.repository.gitlab.sync.alreadyExists':
    'GitLab 已有同名倉庫，已完成連結',
  'pages.repository.gitlab.sync.success':
    '已同步到 GitLab 專案群組 {groupPath}',
  'pages.repository.gitlab.sync.incomplete': 'GitLab 同步未完成：{reason}',
  'pages.repository.gitlab.sync.createFailed':
    '本地程式碼倉庫已建立，但 GitLab 同步失敗。可編輯倉庫並重新同步。',
};
